<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="notification-list-sidebar" position="left" lockedOpen="gt-md">
        <discount-list-sidebar></discount-list-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div class="h2 mb-24">{{'Discount data'|translate}}</div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Name'|translate}}</mat-label>
                            <input matInput formControlName="name" required>
                            <mat-error>{{'Name is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Value'|translate}}</mat-label>
                            <input matInput formControlName="value" required>
                            <mat-error>{{'Value is required!'|translate}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Type'|translate}}</mat-label>
                            <mat-select formControlName="type" required>
                                <mat-option [value]="type.id" *ngFor="let type of types">
                                    {{type.name|translate}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{'Type is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Minimal quantity of products'|translate}}</mat-label>
                            <input matInput formControlName="minimalQuantityOfProducts">
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Minimal quantity of lines'|translate}}</mat-label>
                            <input matInput formControlName="minimalQuantityOfLines">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Minimal quantity of vouchers'|translate}}</mat-label>
                            <input matInput formControlName="minimalQuantityOfVouchers">
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Voucher groups'|translate}}</mat-label>

                            <mat-select placeholder="{{'Groups'|translate}}" [compareWith]="compareObjects"
                                        formControlName="voucherGroups" [(value)]="discount.voucherGroups" multiple>
                                <mat-option *ngFor="let group of groupsList.items"
                                            [value]="group">{{group.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>


                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="availableOneTimeFirstDay" fxFlex="50">
                            <mat-label>{{'Available one time first day'|translate}}</mat-label>
                        </mat-checkbox>
                        <mat-checkbox formControlName="canConnect" fxFlex="50">
                            <mat-label>{{'Can connect with other discounts'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="netPriceDiscount" fxFlex="50">
                            <mat-label>{{'Discount calculated from net price'|translate}}</mat-label>
                        </mat-checkbox>
                        <mat-checkbox formControlName="grossPriceDiscount" fxFlex="50">
                            <mat-label>{{'Discount calculated from gross price'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Available from date'|translate}}</mat-label>
                            <input matInput formControlName="fromDate" [matDatepicker]="picker">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Available to date'|translate}}</mat-label>
                            <input matInput formControlName="toDate" [matDatepicker]="picker2">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
